import { render } from "./UserProfileViewModalTemplate.vue?vue&type=template&id=31a397ed&ts=true"
import script from "./UserProfileViewModalTemplate.vue?vue&type=script&lang=ts"
export * from "./UserProfileViewModalTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__